import React, {memo, useRef} from "react";
import PropTypes from "prop-types";
import {IconButton} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import StyledTooltip from "../tooltips/StyledTooltip";

const ACCEPTED_TYPES = ".pdf,.docx,.doc,.xlsx,.xls,.csv,.txt,.md,.html,.png,.jpg,.jpeg,.gif";

const DocumentAttachButton = memo(({onAttach, disabled, maxReached, maxAttachments}) => {
  const fileInputRef = useRef(null);

  const handleClick = () => fileInputRef.current?.click();

  const handleChange = async (event) => {
    const files = [...(event.target.files || [])];
    for (const file of files) {
      await onAttach(file);
    }
    event.target.value = "";
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept={ACCEPTED_TYPES}
        multiple
        onChange={handleChange}
        hidden
        id="document-attach-button-input"
      />
      <StyledTooltip
        enterDelay={800}
        maxWidth={360}
        title={(
          <>
            Attach
            {" "}
            {maxAttachments ? `up to ${maxAttachments} ` : ""}
            files
            <ul style={{margin: "4px 0 0", paddingLeft: 16}}>
              <li>Documents: PDF, DOCX, DOC, XLSX, XLS, CSV, TXT, MD, HTML</li>
              <li>Images: PNG, JPEG, GIF</li>
              <li>Max size: 25MB PDFs, 4.5MB non-PDF docs, 3.75MB images</li>
              <li>Max PDF pages: 200</li>
            </ul>
          </>
        )}
        placement="top"
      >
        <span>
          <IconButton
            onClick={handleClick}
            disabled={disabled || maxReached}
            size="small"
            disableRipple
            id="document-attach-icon-button"
          >
            <AttachFileIcon sx={{color: "text.secondary"}} />
          </IconButton>
        </span>
      </StyledTooltip>
    </>
  );
});

DocumentAttachButton.displayName = "DocumentAttachButton";

DocumentAttachButton.propTypes = {
  onAttach: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  maxReached: PropTypes.bool,
  maxAttachments: PropTypes.number,
};

export default DocumentAttachButton;
